<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false"
      :title="program.is_amenagement ? 'Création d\'un lotissement' : 'Création d\'un programme'">
    </page-nav-bar>
    <program-form
      @submit="createProgram"
      :source-loading="loading"
      :source-submit-loading="submitLoading"></program-form>
  </div>
</template>

<script>
import ProgramMixin from './ProgramMixin'

export default {
  name: 'ProgramCreate',
  components: {
    ProgramForm: () => import('@/components/programs/ProgramForm')
  },
  mixins: [ProgramMixin],
  methods: {
  }
}
</script>
